
	module.exports = function wrapArray(numberStringOrArray) {
		if(Array.isArray(numberStringOrArray)) {
			return numberStringOrArray
		} else {
			return [ numberStringOrArray ]
		}
	}
	